import { sortCarsTypes } from "./../components/sections/cars/static.sortCarsTypes";
import { sortDirections } from "./../components/sections/cars/static.sortDirections";

import {
  REQUEST_CLEAR_FILTER,
  READY_CLEAR_FILTER,
  REQUEST_CHANGE_STORE_CARSFILTER,
  READY_CHANGE_STORE_CARSFILTER,
  CONFIRM_STORE_CARSFILTER,
} from "../actions/filterCarsActions";

import { RESPONSE_WINTER_AREAS_SIMPLE } from "../actions/winterMaintenceAction";

import { states } from "./queriesStates";

const initialState = {
  dataState: states.NOT_REQUESTED,
  clearDataState: states.NOT_REQUESTED,
  filterItems: {
    winterCompanies: [],
    orderBy: sortCarsTypes[0].type,
    orderDesc: sortDirections.asc,
    sensors: [],
    count: -1,
    filterCount: 0,
    page: -1,
  },
};

const setFilterCarsCount = (filterItems) => {
  var counter = 0;

  const checkFilter = (key) => {
    if (filterItems[key] !== undefined && filterItems[key] === true) {
      counter++;
    }
  };

  if (filterItems.groups !== undefined && filterItems.groups !== null && filterItems.groups.length > 0) {
    counter++;
  }

  if (filterItems.winterCompanies !== undefined && filterItems.winterCompanies !== null && filterItems.winterCompanies.length > 0) {
    counter++;
  }

  Object.keys(filterItems).forEach((filterItem) => {
    checkFilter(filterItem);
  });

  return filterItems.filterCount !== counter ? counter : filterItems.filterCount;
};

const filterCarsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CLEAR_FILTER: {
      return Object.assign({}, state, {
        clearDataState: states.REQUEST,
      });
    }
    case READY_CLEAR_FILTER: {
      return Object.assign({}, state, {
        clearDataState: states.READY,
        filterItems: initialState.filterItems,
      });
    }
    case REQUEST_CHANGE_STORE_CARSFILTER: {
      return Object.assign({}, state, {
        dataState: states.REQUEST,
      });
    }
    case READY_CHANGE_STORE_CARSFILTER: {
      const { name, value } = action.payload;

      const filterItems = Object.assign({}, state.filterItems);

      typeof name === "object"
        ? name.map((item, index) => {
            filterItems[item] = value[index];
            return null;
          })
        : (filterItems[name] = value);

      if (name !== "page" && state.filterItems.page === filterItems.page) filterItems.page = initialState.filterItems.page;

      filterItems["filterCount"] = setFilterCarsCount(filterItems);

      filterItems.sensors = [];

      Object.keys(sensorsValue).forEach((key) => {
        if (filterItems[key] === true) {
          filterItems.sensors.push(sensorsValue[key]);
        }
      });

      return Object.assign({}, state, {
        dataState: states.READY,
        confirmFilterDataState: state.REQUEST,
        filterItems: filterItems,
      });
    }

    case CONFIRM_STORE_CARSFILTER: {
      return Object.assign({}, state, {
        confirmFilterDataState: states.READY,
      });
    }

    case RESPONSE_WINTER_AREAS_SIMPLE:
      const getChildrenWintrerCompanies = (winterAreas) => { 

        const companies = [];

        winterAreas.forEach((area) => {
          area.parentCompanies.forEach((parentCompany) => {
            parentCompany.companies.forEach((company) => {
              companies.push({
                label: company.title,
                value: company.id,
              });
            });
          });
        });

        return companies;
      };

      const filterItems = Object.assign({}, state.filterItems);
      filterItems["_currentWintrerCompanies"] = getChildrenWintrerCompanies(action.data.areas);

      return Object.assign({}, state, {
        filterItems: filterItems,
      });

    default:
      return state;
  }
};

const sensorsValue = {
  sensorFuel: 1,
  sensorFlowMeter: 2,
  sensorEquipment: 3,
  sensorSand: 4,
  sensorDump: 5,
  sensorVideo: 6,
  sensorTemperature: 7,
  sensorDistance: 8,
};

export default filterCarsReducer;
